module.exports = __webpack_public_path__ + "static/media/chess-bishop.ff6cdb79.svg";